import Button from '@eversports/klimt-primitives/alpha/Button'
import { useTranslations } from 'next-intl'

interface Props {
  showCookiePreferences: boolean
  toggleCookiePreferences: () => void
  handleClickAccept: () => void
  handleClickConfirm: () => void
}

export const CookieButtons = ({
  showCookiePreferences,
  toggleCookiePreferences,
  handleClickAccept,
  handleClickConfirm,
}: Props) => {
  const t = useTranslations('cookies')
  return (
    <div className="flex flex-col gap-2 text-sm md:flex-row">
      {showCookiePreferences ? (
        <Button variant="outline" className="flex-1 p-1" onClick={handleClickConfirm}>
          {t('confirm')}
        </Button>
      ) : (
        <Button variant="outline" className="flex-1 p-1" onClick={toggleCookiePreferences}>
          {t('see-preferences')}
        </Button>
      )}
      <Button className="flex-2 p-1" onClick={handleClickAccept}>
        {t('accept-all')}
      </Button>
    </div>
  )
}
